export const domain = 'ProductSearch';

// action types
export const FETCH_ERROR = `${domain}/FETCH_ERROR`;
export const RECEIVE_PRODUCTS = `${domain}/RECEIVE_PRODUCTS`;
export const IS_FETCHING = `${domain}/IS_FETCHING`;
export const PRODUCTS = 'products';
